import React, { useContext, useEffect, useState } from "react"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import { trackPromise, usePromiseTracker } from "react-promise-tracker"
import { ceritificationPackageService } from "services/certification.certificationPackage"
import "./CertificationPackage.css"
import CertificationPackageComponent from "./CertificationPackageComponent"
import { GlobalAlertContext } from 'context/GlobalAlertContext';

import MCSOverlayLoading from "components/MCSOverlayLoading"
import MCSGridRevert from "components/MCSGridRevert"

const CertificationPackagePage = () => {
    const { packageId } = useParams()
    const alertContext = useContext(GlobalAlertContext);
    const { promiseInProgress } = usePromiseTracker();
    const [certificationPackage, setCertificationPackage] = useState(null);
    const [certificationPackageConstants, setCertificationPackageConstants] = useState(null);

    const loadPackage = async () => {
        trackPromise(
            ceritificationPackageService.GetCertificationPackage(packageId)
                .then((response) => {
                    if (response.status === 200) {
                        setCertificationPackage(response.data.result)
                    } else {
                        alertContext.setErrorMessage("Error Loading Certification Package")
                    }
                })
                .catch(() => alertContext.setErrorMessage("Error Loading Certification Package"))
        )
    }

    const loadConstants = async () => {
        trackPromise(
            ceritificationPackageService.GetCertificationPackageConstants()
                .then((response) => {
                    if (response.status === 200) {
                        setCertificationPackageConstants(response.data.result)
                    } else {
                        alertContext.setErrorMessage("Error Loading Certification Package Constants")
                    }
                })
                .catch(() => alertContext.setErrorMessage("Error Loading Certification Package Constants"))
        )
    }

    useEffect(() => { certificationPackage || loadPackage() }, [certificationPackage]);
    useEffect(() => { certificationPackageConstants || loadConstants() }, [certificationPackageConstants]);

    return (
        <>
            {promiseInProgress && <MCSOverlayLoading />}
            <MCSGridRevert>
                {certificationPackage && certificationPackageConstants &&
                    <CertificationPackageComponent
                        loadedPackage={certificationPackage}
                        loadedConstants={certificationPackageConstants} />}
            </MCSGridRevert>

        </>

    )
}

export default CertificationPackagePage